import React from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '../../components/ProtectedRoute';
import { lazyWithRetry } from '../../lib/lazyWithRetry';

const TeamTimeDashboard = lazyWithRetry(() => import('../../pages/FieldService/TeamTimeDashboard'));
const EmployeeDayDetail = lazyWithRetry(() => import('../../pages/FieldService/EmployeeDayDetail'));
const TimesheetApproval = lazyWithRetry(() => import('../../pages/FieldService/TimesheetApproval'));
const PayrollExport = lazyWithRetry(() => import('../../pages/FieldService/PayrollExport'));
const TimeTrackingConfig = lazyWithRetry(() => import('../../pages/Admin/TimeTrackingConfig'));

function TimeOffPlaceholder() {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <p className="text-slate-500 text-lg">Time Off Requests coming soon</p>
    </div>
  );
}

export const routes: RouteObject[] = [
  // All of these expose the whole team's hours, GPS trails, flags, manager
  // notes and the payroll export — manager/admin only, matching settings.
  {
    index: true,
    element: <ProtectedRoute requireManagerOrAdmin><TeamTimeDashboard /></ProtectedRoute>,
  },
  {
    path: 'employee/:employeeId/:date',
    element: <ProtectedRoute requireManagerOrAdmin><EmployeeDayDetail /></ProtectedRoute>,
  },
  {
    path: 'timesheet-approval',
    element: <ProtectedRoute requireManagerOrAdmin><TimesheetApproval /></ProtectedRoute>,
  },
  {
    path: 'payroll-export',
    element: <ProtectedRoute requireManagerOrAdmin><PayrollExport /></ProtectedRoute>,
  },
  {
    path: 'time-off-requests',
    element: <ProtectedRoute requireManagerOrAdmin><TimeOffPlaceholder /></ProtectedRoute>,
  },
  {
    // Retired 2026-10-18: Support -> On-Call is the one place to set who is on call. The old link
    // (bookmarks, emailed links) redirects there; Support's own route guards apply.
    path: 'on-call',
    element: <Navigate to="/support/on-call" replace />,
  },
  {
    path: 'settings',
    element: <ProtectedRoute requireManagerOrAdmin><TimeTrackingConfig /></ProtectedRoute>,
  },
  // One real route per settings tab, so a menu link names a declared page (the tab is read from the address).
  {
    path: 'settings/holidays',
    element: <ProtectedRoute requireManagerOrAdmin><TimeTrackingConfig /></ProtectedRoute>,
  },
  {
    path: 'settings/flags',
    element: <ProtectedRoute requireManagerOrAdmin><TimeTrackingConfig /></ProtectedRoute>,
  },
  {
    path: 'settings/on-call',
    element: <ProtectedRoute requireManagerOrAdmin><TimeTrackingConfig /></ProtectedRoute>,
  },
  {
    // Anything else under settings still opens the page (on Pay Rules) rather than a blank screen.
    path: 'settings/*',
    element: <ProtectedRoute requireManagerOrAdmin><TimeTrackingConfig /></ProtectedRoute>,
  },
];
